import { Button } from "@/components/ui/Button";
import { Wordmark } from "@/components/ui/Wordmark";
import { GlobeIcon } from "@/components/ui/icons";

/**
 * No network.
 *
 * Shown only when `navigator.onLine` is `false`, which is the one state the
 * browser can tell us about with confidence. Everything else — the API being
 * down, a blocked origin, a bad gateway — is *not* this screen, because
 * "check your internet connection" sends someone to restart a router that was
 * never the problem.
 *
 * It recovers on its own. The `online` event re-renders the tree and the
 * queries underneath resume, so the reload button is there for the case where
 * the browser is wrong rather than as the way out.
 *
 * Nothing technical on it. There is no url, no status code and no mention of
 * CORS: a person who has lost wifi cannot use any of that, and a person who
 * can is looking at the console anyway.
 */
export function OfflineScreen() {
  return (
    <div className="bg-canvas flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <Wordmark className="mb-10" />

      <span
        aria-hidden="true"
        className="bg-surface-sunken text-content-subtle mb-6 flex size-16 items-center justify-center rounded-full"
      >
        <GlobeIcon className="size-7" />
      </span>

      <h1 className="text-content text-xl font-bold tracking-tight">You're offline</h1>

      <p className="text-content-muted mt-2.5 max-w-sm text-sm leading-relaxed">
        This device has lost its connection. The panel will pick up where it left off as soon as
        you're back on a network.
      </p>

      <Button variant="secondary" className="mt-7" onClick={() => window.location.reload()}>
        Try again
      </Button>
    </div>
  );
}
